import { abPlugin } from '@webplatform/asbis-ui';
import Vue from 'vue';
import { createDataLoaders } from '~/domains/asbis-ui';

Vue.config.ignoredElements = ['swiper-container', 'swiper-slide'];

// eslint-disable-next-line func-names
export default function ({
  $gsap,
  $ScrollTrigger,
  app,
  $api,
  $axios,
  $config,
}: any) {
  const localePathFn =
    typeof app.localePath === 'function' ? app.localePath : (path: any) => path;

  const { fetchProducts, fetchPromotion, fetchInstagramPosts, fetchPages } =
    createDataLoaders($api, $axios);

  Vue.use(abPlugin, {
    gsap: $gsap,
    theme: 'prestigio',
    ScrollTrigger: $ScrollTrigger,
    productCardLinkPrefix: '/product',
    localePath: localePathFn,
    googleMapsApiKey: $config.gmapId,
    dataFetchFunctions: {
      fetchProducts,
      fetchPromotion,
      fetchInstagramPosts,
      fetchPages,
    },
  });
}
